var Localization = new Object();

// languages.  (must match the file name)
const dutch = "de";
const english = "en";
const spanish = "ESP";
const french = "fr";
const italian = "it";
const japanese = "ja";
const korean = "KOR";
const polish = "pl";
const portugese = "pt";
const turkish = "tr";
const chinese = "zh";

// different keys that might mean the same languages.
// (file name as default key for legacy consumers)
const languageKeys = {
    [dutch]:dutch,
    "de-DE": dutch,
    "DE": dutch,

    [english]:english,
    "en-US": english,
    "US": english,
    
    [spanish]:spanish,
    "es-ES": spanish,
    "ES": spanish,

    [french]:french,
    "fr-FR": french,
    "FR": french,

    [italian]:italian,
    "it-IT": italian,
    "IT": italian,

    [japanese]:japanese,
    "ja-JP": japanese,
    "JA": japanese,

    [korean]:korean,
    "ko-KR": korean,
    "KO": korean,

    [polish]:polish,
    "pl-PL": polish,

    [portugese]:portugese,
    "pt-BR": portugese,

    [turkish]:turkish,
    "tr-TR": turkish,

    [chinese]:chinese,
    "zh-CN": chinese,
    "zh-TW": chinese,
    "ZH": chinese,
}

//set user language e.g. locale "en", "ja", "zh", "de" 
Localization.getLocaleStrings = function (userLocale) {
    var localeStrings = {};

    let language = languageKeys[userLocale];

    if(language){
        localeStrings = require('../localization/' + language + '.js');
    } else {
        localeStrings = require('../localization/' + english + '.js');
    }

    return localeStrings;
};

module.exports = Localization;